import { render, staticRenderFns } from "./default.vue?vue&type=template&id=30169df6"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutFooter: require('C:/Users/Maristela/loja/components/Layout/Footer.vue').default,LayoutHeader: require('C:/Users/Maristela/loja/components/Layout/Header.vue').default,ButtonFloatWhatsapp: require('C:/Users/Maristela/loja/components/ButtonFloatWhatsapp.vue').default,PoliticaCookie: require('C:/Users/Maristela/loja/components/PoliticaCookie.vue').default})
